import React, { useState, useEffect } from "react";
import add from "../../images/add.svg";
import {
  Grid,
  Typography,
  Box,
  styled,
  Dialog,
  DialogContent,
  Button,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
} from "@mui/material";
import moment from "moment";
import billImg from "../../images/bill.png";
import { Link, useHistory } from "react-router-dom";
import BillPreview from "../reusableComponents/BillPreview";
import deleteIcon from "../../images/delete.png";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import { useDispatch, useSelector } from "react-redux";
import { getInvoices, removeInvoice, removebyIndex } from "./invoiceSlice";
import { deleteInvoice } from "./httpCalls";
import Search from "../components/Search";
import { BodyContainer, ButtonAdd, Header, TopGrid } from "../styles";
import DateField from "../components/DateField";
import Loader from "../components/Loader";
import InvoicePrint from "./InvoicePrint";
import ReactToPrint from "react-to-print";
import { useRef } from "react";

const ItemBox = styled(Grid)({
  height: "60px",
  backgroundColor: "#FFFFFF",
  borderRadius: "4px",
  display: "flex",
  alignItems: "center",
  padding: "0px 5px",
  marginTop: "5px",
  display: "flex",
  alignItems: "center",
});

const Text = styled(Typography)({
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
});

function Invoices() {
  const dispatch = useDispatch();
  const companyCode = localStorage.getItem("companyCode");
  let titleType = "";
  if (companyCode == 7149) {
    titleType = "Estimate";
  } else {
    titleType = "Invoice";
  }

  const printRef = useRef();
  const { invoices, saleInvoices, purchaseInvoices, oldInvoices, loading } =
    useSelector((state) => state?.invoice);
  console.log("invoices:", invoices);
  const [invoiceType, setInvoiceType] = useState("Sale");
  const [state, setState] = useState({
    searchText: "",
    date: "",
    modal: false,
    deleteModal: false,
    bill: "",
    deleteId: "",
    deleteIndex: "",
    index: null,
    newModal: false,
  });
  const [modal, setModal] = useState(false);
  console.log("invoices", invoices);
  console.log("saleInvoices", saleInvoices);
  console.log("purchaseInvoices", purchaseInvoices);

  console.log("oldInvoices", oldInvoices);

  useEffect(() => {
    // if (invoices.length == 0) {
    dispatch(getInvoices());
    // }
  }, []);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const searchedItems = () => {
    if (state.searchText != "") {
      if (invoiceType == "Sale") {
        const filtered = saleInvoices?.filter((item) =>
          item?.invoiceNumber?.toString().startsWith(state.searchText)
        );
        return filtered;
      } else if (invoiceType == "Purchase") {
        const filtered = purchaseInvoices?.filter((item) =>
          item?.invoiceNumber?.toString().startsWith(state.searchText)
        );
        return filtered;
      } else if (invoiceType == "Old") {
        const filtered = oldInvoices?.filter((item) =>
          item?.invoiceNumber?.toString().startsWith(state.searchText)
        );
        return filtered;
      }
    } else if (state.date != "") {
      let newDate = moment(state?.date).format("DD-MM-YYYY");
      if (invoiceType == "Sale") {
        const filtered = saleInvoices?.filter(
          (item) => moment.unix(item.created_at).format("DD-MM-YYYY") == newDate
        );
        return filtered;
      } else if (invoiceType == "Purchase") {
        const filtered = purchaseInvoices?.filter(
          (item) => moment.unix(item.created_at).format("DD-MM-YYYY") == newDate
        );
        return filtered;
      } else if (invoiceType == "Old") {
        const filtered = oldInvoices?.filter(
          (item) => moment.unix(item.created_at).format("DD-MM-YYYY") == newDate
        );
        return filtered;
      }
    } else {
      if (invoiceType == "Sale") {
        return saleInvoices;
      } else if (invoiceType == "Purchase") {
        return purchaseInvoices;
      } else if (invoiceType == "Old") {
        return oldInvoices;
      }
    }
  };

  const newToggle = () => {
    setModal((prev) => !prev);
  };

  const toggleImage = (item) => {
    if (item?.ledger) {
      setState((prev) => ({ ...prev, bill: item }));
      newToggle();
    } else {
      setState((prev) => ({ ...prev, bill: item, modal: !prev.modal }));
    }
  };

  const deleteToggle = (id = "", index = null) => {
    setState((prev) => ({
      ...prev,
      deleteId: id,
      index: index,
      deleteModal: !prev.deleteModal,
    }));
  };

  const handleDelete = async () => {
    deleteToggle();
    if (state.date || state.searchText) {
      dispatch(removeInvoice({ id: state.deleteId }));
    } else {
      dispatch(removebyIndex({ index: state.index }));
    }
    await deleteInvoice({ id: state.deleteId, dispatch });
  };
  const handleType = (e) => {
    let { value } = e.target;
    setInvoiceType(value);
  };

  const onAfter = () => {
    setTimeout(() => {
      console.log("Redirecting...");
      history.push("/inventory/admin/invoices");
    }, 3000);
  };
  return (
    <Box>
      <Header sx={{ mt: { md: "0px", xs: "40px" } }}>
        <TopGrid container alignItems="center" spacing={0.5}>
          <Grid item md={3} xs={12} className="ml-n-16">
            <Search
              name={"searchText"}
              text={"Search item..."}
              value={state.searchText}
              onChange={handleInput}
            />
          </Grid>
          <Grid align="center" item lg={6} md={4} xs={12}>
            <Typography variant="h5" sx={{ color: "white" }}>
              {titleType}
            </Typography>
          </Grid>
          <Grid align="center" item lg={2} md={3} xs={6} className="ml-n-16">
            <DateField
              name={"date"}
              value={state?.date}
              onChange={handleInput}
            />
          </Grid>
          <Grid align="center" item lg={1} md={2} xs={4}>
            <Link to="/inventory/admin/add-invoice">
              <ButtonAdd variant="contained" fullWidth>
                Add <img src={add} alt="add" />
              </ButtonAdd>
            </Link>
          </Grid>
        </TopGrid>
      </Header>

      <BodyContainer sx={{ mb: 3 }}>
        <FormControl
          size="small"
          sx={{ width: { xs: "100%", sm: "60%", md: "25%" } }}
        >
          <InputLabel>Invoice Type</InputLabel>
          <Select
            fullWidth
            size="small"
            variant="outlined"
            name="invoiceType"
            value={invoiceType}
            label="Invoice Type"
            onChange={handleType}
          >
            <MenuItem value="Sale">Sale Invoice</MenuItem>
            <MenuItem value="Purchase">Purchase Invoice</MenuItem>
            {oldInvoices?.length > 0 && (
              <MenuItem value="Old">Old Invoice</MenuItem>
            )}
          </Select>
        </FormControl>
        {!loading &&
          searchedItems()?.map((item, index) => {
            console.log("item");
            let senderName;
            let recName;
            let sd = item.senderDetails;
            let rd = item.receiverDetails;
            if (sd?.firstName || sd?.lastName) {
              senderName = sd?.firstName + " " + sd?.lastName;
            } else {
              senderName = "";
            }
            if (rd?.firstName || rd?.lastName) {
              recName = rd?.firstName + " " + rd?.lastName;
            } else {
              recName = "";
            }
            return (
              <ItemBox key={index} container columns={24}>
                <Grid item align="center" xs={1}>
                  <Typography className="f-8">{index + 1}</Typography>
                </Grid>

                <Grid item xs={3}>
                  <img
                    src={billImg}
                    style={{ cursor: "pointer" }}
                    height="50px"
                    onClick={() => toggleImage(item)}
                  />
                </Grid>

                <Grid item xs={4} sx={{ color: "#4eaf51", pl: 3 }}>
                  <Typography sx={{ color: "#4eaf51" }} className="f-8">
                    {titleType} No.
                  </Typography>

                  <Typography className="f-8">{item?.invoiceNumber}</Typography>
                </Grid>
                <Grid item xs={8}>
                  {item?.senderDetails && (
                    <Box
                      sx={{ display: "grid", gridTemplateColumns: "25% 75%" }}
                    >
                      <Typography
                        sx={{ color: "#4eaf51", mr: 1 }}
                        className="f-8"
                      >
                        From
                      </Typography>
                      <Text>{senderName}</Text>
                    </Box>
                  )}
                  {item?.senderDetails && (
                    <Box
                      sx={{ display: "grid", gridTemplateColumns: "25% 75%" }}
                    >
                      <Typography
                        sx={{ color: "#4eaf51", mr: 1 }}
                        className="f-8"
                      >
                        To
                      </Typography>
                      <Text>{recName}</Text>
                    </Box>
                  )}
                  {item?.ledger && (
                    <Box>
                      <Typography
                        sx={{
                          color: "#4eaf51",
                          mr: 1,
                          fontSize: { md: "14px", xs: "8px" },
                        }}
                        // className="f-8"
                      >
                        Customer
                      </Typography>
                      <Text sx={{ fontSize: { md: "14px", xs: "8px" } }}>
                        {typeof item?.ledger?.name === "string"
                          ? item.ledger.name
                          : item?.ledger &&
                            Object.keys(item.ledger).length === 0
                          ? "N/A"
                          : String(item.ledger)}
                      </Text>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <Typography sx={{ color: "#4eaf51", mr: 1 }} className="f-8">
                    Total Amount
                  </Typography>
                  <Typography className="f-8"> {item?.total} </Typography>
                </Grid>

                <Grid item xs={3}>
                  <Typography sx={{ color: "#4eaf51", mr: 1 }} className="f-8">
                    Date
                  </Typography>
                  <Typography className="f-8">
                    {moment.unix(item?.created_at).format("DD-MM-YYYY")}
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <img
                    src={deleteIcon}
                    alt="delete"
                    style={{ cursor: "pointer" }}
                    onClick={() => deleteToggle(item._id, index)}
                  />
                </Grid>
              </ItemBox>
            );
          })}
      </BodyContainer>

      <BillPreview
        title="Bill Preview"
        open={state.modal}
        onClose={toggleImage}
        onClickCancel={toggleImage}
        bill={state.bill}
        invoicePrint="true"
      />

      <DeleteDialog
        title="Delete Invoice"
        open={state.deleteModal}
        onClose={deleteToggle}
        onClickYes={handleDelete}
      />

      <Loader loading={loading} />
      <Dialog open={modal} onClose={newToggle} fullWidth maxWidth="md">
        <DialogContent>
          <ReactToPrint
            trigger={() => (
              <Button variant="contained" sx={{ textTransform: "none" }}>
                Print
              </Button>
            )}
            content={() => printRef.current}
          />

          <InvoicePrint ref={printRef} state={state?.bill} />
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default Invoices;
